import React from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
import { FooterObject, socialMediaLink } from "../pages/HomePage/Data";
import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaLinkedin,
  FaGithub,
} from "react-icons/fa";
import { ImMail } from "react-icons/im";
import { HiOutlineDesktopComputer } from "react-icons/hi";

const FooterContainer = styled.div`
  background-color: #101522;
  padding: 4rem 0 2rem 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const FooterSubscription = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-bottom: 24px;
  padding: 24px;
  color: #fff;
`;

const FooterSubHeading = styled.p`
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  margin-bottom: 24px;
  font-size: 24px;
`;

const FooterLinksContainer = styled.div`
  width: 100%;
  max-width: 1000px;
  display: flex;
  justify-content: center;

  @media screen and (max-width: 820px) {
    padding-top: 32px;
  }
`;

export const FooterLinksWrapper = styled.div`
  display: flex;

  @media screen and (max-width: 820px) {
    flex-direction: column;
  }
`;

const FooterLinkItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 16px;
  text-align: left;
  width: 160px;
  box-sizing: border-box;
  color: #fff;

  @media screen and (max-width: 420px) {
    margin: 0;
    padding: 10px;
    width: 100%;
  }
`;

const FooterLinkTitle = styled.h2`
  margin-bottom: 16px;
`;

const FooterLink = styled.a`
  color: #fff;
  text-decoration: none;
  margin-bottom: 0.5rem;
  display: flex;
  &:hover {
    color: #0467fb;
    transition: 0.3s ease-out;
  }
`;

export const SocialMedia = styled.section`
  max-width: 1000px;
  width: 100%;
`;

const SocialMediaWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  max-width: 1000px;
  margin: 40px auto 0 auto;

  @media screen and (max-width: 820px) {
    flex-direction: column;
  }
`;

const SocialLogo = styled(Link)`
  color: #fff;
  justify-self: start;
  cursor: pointer;
  text-decoration: none;
  font-size: 1rem;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

const WebsiteRights = styled.small`
  color: #fff;
  margin-bottom: 16px;
`;

const SocialIcons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 240px;
`;

const SocialIconLink = styled.a`
  color: #fff;
  font-size: 24px;
`;

const LinkText = styled.div`
  margin-left: 10px;
`;

const NavIcon = styled(HiOutlineDesktopComputer)`
  margin-right: 0.5rem;
  color: white;
`;

const Footer = () => {
  return (
    <FooterContainer id={FooterObject.id}>
      <FooterSubscription>
        <FooterSubHeading>{FooterObject.subHeading}</FooterSubHeading>
        <FooterSubHeading>{FooterObject.projectInformation}</FooterSubHeading>
      </FooterSubscription>
      <FooterLinksContainer>
        <FooterLinksWrapper>
          <FooterLinkItems>
            <FooterLinkTitle>{FooterObject.contact.title}</FooterLinkTitle>
            <FooterLink href={socialMediaLink.linkedIn}>
              <FaLinkedin />
              <LinkText>{FooterObject.contact.linkedIn} </LinkText>
            </FooterLink>
            <FooterLink href={socialMediaLink.github}>
              <FaGithub />
              <LinkText>{FooterObject.contact.github}</LinkText>
            </FooterLink>
            <FooterLink href={socialMediaLink.gmail}>
              <ImMail />
              <LinkText>{FooterObject.contact.gmail}</LinkText>
            </FooterLink>
          </FooterLinkItems>
        </FooterLinksWrapper>
        <FooterLinksWrapper>
          <FooterLinkItems>
            <FooterLinkTitle>Social Media</FooterLinkTitle>
            <FooterLink href={socialMediaLink.instagram}>
              <FaInstagram />
              <LinkText>{FooterObject.contact.instagram}</LinkText>
            </FooterLink>
            <FooterLink href={socialMediaLink.facebook}>
              <FaFacebook />
              <LinkText>{FooterObject.contact.facebook}</LinkText>
            </FooterLink>
            <FooterLink href={socialMediaLink.youtube}>
              <FaYoutube />
              <LinkText>{FooterObject.contact.youtube}</LinkText>
            </FooterLink>
          </FooterLinkItems>
        </FooterLinksWrapper>
      </FooterLinksContainer>
      <SocialMedia>
        <SocialMediaWrap>
          <SocialLogo to="about-page" smooth={true} duration={7000}>
            {FooterObject.disclaimer}
          </SocialLogo>
          <WebsiteRights></WebsiteRights>
          <SocialIcons>
            <SocialIconLink
              href={socialMediaLink.facebook}
              target="_blank"
              aria-label="Facebook"
            >
              <FaFacebook />
            </SocialIconLink>
            <SocialIconLink
              href={socialMediaLink.instagram}
              target="_blank"
              aria-label="Instagram"
            >
              <FaInstagram />
            </SocialIconLink>
            <SocialIconLink
              href={socialMediaLink.youtube}
              rel="noopener noreferrer"
              target="_blank"
              aria-label="Youtube"
            >
              <FaYoutube />
            </SocialIconLink>
            <SocialIconLink
              href={socialMediaLink.linkedIn}
              target="_blank"
              aria-label="LinkedIn"
            >
              <FaLinkedin />
            </SocialIconLink>
          </SocialIcons>
        </SocialMediaWrap>
      </SocialMedia>
    </FooterContainer>
  );
};

export default Footer;
